<template>
  <div class="app-container">
    <transition-group name="el-zoom-in-center">
      <!-- 项目头部列表 -->
      <div v-show="showList" key="header" class="filter-container">
        <el-input v-model="listQuery.userName" placeholder="请输入用户名" style="width:200px;"/>
        <el-date-picker
          v-model="listQuery.time"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
        <el-button
          v-waves
          v-if="calcPermission(permition, 1)"
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
        >{{ $t('table.search') }}</el-button>
      </div>
      <!-- 项目列表 -->
      <div v-show="showList" key="list" class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="tableKey"
          :data="list"

          fit
          stripe
          highlight-current-row
          style="width: 100%;"
        >
          <el-table-column :label="$t('table.id')" align="center" width="50px">
            <template slot-scope="scope">
              <span>{{ (scope.$index + 1) + ((listQuery.pageIndex - 1) * listQuery.pageSize) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.accountId')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.AccountId">{{ scope.row.AccountId }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.type')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.Type">{{ scope.row.Type }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.currency')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.Rmb">{{ scope.row.Rmb }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.memo')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.Memo">{{ scope.row.Memo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.addUser')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.AddUserId">{{ scope.row.AddUserId }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.addTime')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.AddTime">{{ scope.row.AddTime }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('table.actions')"
            align="center"
            lass-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <el-button
                v-if="calcPermission(permition, 1)"
                size="mini"
                type="primary"
                @click="handleDetail(scope.row)"
              >{{ $t('table.detail') }}</el-button>
              <el-button
                v-if="calcPermission(permition, 2)"
                size="mini"
                type="danger"
                @click="deleteProject(scope.row)"
              >{{ $t('table.delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            v-show="total>0"
            :current-page="listQuery.pageIndex"
            :page-sizes="[10,20,50,100]"
            :page-size="listQuery.pageSize"
            :total="total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { qryRoleInfo } from '@/api/baseModule'
import { qryAccountFlow } from '@/api/account'

import waves from '@/directive/waves' // 水波纹指令
export default {
  directives: {
    waves
  },
  data() {
    return {
      listQuery: {
        pageIndex: 1,
        pageSize: 10,
        userName: null,
        time: null
      },
      list: null,
      showList: true,
      permition: 0,
      listLoading: true,
      tableKey: 0,
      total: null
    }
  },
  created() {
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList.forEach(item => {
        item.RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            this.qryList()
          }
        })
      })
    } else {
      qryRoleInfo({
        rId: this.$store.getters.roles.RoleId
      }).then(response => {
        // this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            this.qryList()
          }
        })
      })
    }
  },
  methods: {
    // 查询列表
    qryList() {
      const dataForm = {
        pageIndex: 1,
        pageSize: 10,
        time: this.listQuery.time,
        userName: this.listQuery.userName
      }
      qryAccountFlow(dataForm).then(response => {
        this.list = response.Data
        this.total = response.TotalRows
        this.listLoading = false
        this.resetTemp()
      })
    },
    // 重置查询数据
    resetTemp() {
      this.listQuery = {
        pageIndex: this.listQuery.pageIndex,
        pageSize: this.listQuery.pageSize,
        userName: null,
        time: null
      }
    },
    // 修改页容量重新查询列表
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    // 修改页码重新查询列表
    handleCurrentChange(val) {
      this.listQuery.pageIndex = val
      this.getList()
    },
    handleFilter() {
      this.qryList()
    }
  }
}
</script>

<style lang="less">
.el-date-editor{
  .el-range-separator{
    width:8%;
  }
}
</style>
